import DateSince from './DateSince';

export default DateSince;
